module.exports = "/assets/34815b798f620f5aee21f4f62389ae7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SI.png
// module id = 1822
// module chunks = 0